import React from 'react'
import cx from 'classnames'

import { Button } from 'components/shared/Button/Button'

import styles from './IconButton.module.scss'

export const IconButton = ({
  ariaLabel,
  className = undefined,
  color,
  icon,
  message,
  size,
  title,
  variant,
  onClick,
  isDisabled,
  isLocked,
}) => (
  <Button
    className={cx(styles.button, {
      [styles.size]: Boolean(size),
      [styles[size]]: Boolean(size),
      [className]: Boolean(className),
    })}
    {...{
      ariaLabel,
      color,
      icon,
      message,
      size,
      title,
      variant,
      onClick,
      isDisabled,
      isLocked,
    }}
  />
)
